import axios, {AxiosResponse} from "axios";
import {APIS} from "../../../../static/apis";

export function deletePayeeService (companyId: string, payeeId: string): Promise<AxiosResponse<{ data: boolean }>> {
  return axios.delete(
    APIS.BASE_AUTH_MS_URL + APIS.DELETE_PAYEE,
    { params: { companyId, payeeId } }
  );
}
